import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { BookServiceService } from "src/app/services/book-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/Auth/auth.service";

@Component({
  selector: "app-book",
  templateUrl: "./book.component.html",
  styleUrls: ["./book.component.scss"]
})
export class BookComponent implements OnInit {
  @Input() index: number;

  id = this.route.snapshot.paramMap.get("id");
  // public async getpost() {
  //   this.book = await this.bookSer.getBook(this.id);
  //   console.log(this.book);
  // }
  book;
  isfav: boolean;

  user: any;
  Book: any;
  showAlert: boolean;
  isVoted: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bookSer: BookServiceService,
    private auth: AuthService
  ) {}

  books: any;
  sub: Subscription;
  ngOnInit() {
    this.bookSer.gEtBook(this.id).subscribe(data => {
      this.book = data;
      console.log(data);
    });
    this.sub = this.bookSer.allBooks().subscribe(data => {
      this.books = data.map((el: any) => {
        return {
          id: el.payload.doc.id,
          ...el.payload.doc.data()
        };
      });
    });
    // this.icon = document.getElementById("icon");
    // // this.book = this.bookSer.books[this.id];
    //  if (this.book.isVoted == true) {
    //   this.icon.setAttribute("class", "fas");
    // } else {
    //   this.icon.setAttribute("class", "far");
    // }
    // this.getpost();
  }

  back() {
    this.router.navigate(["/"]);
  }
  fav(id) {
    let curBook;
    this.isfav = !this.isfav;
    this.books.map(book => {
      if (book.id === this.id) {
        curBook = book;
      }
    });
    this.auth.User.subscribe(data => {
      this.user = data;
      if (this.user) {
        if (this.isfav) {
          this.Book.ediBook(this.id).update({
            isfav: true
          });
        } else {
          this.Book.ediBook(this.id).update({
            isfav: false
          });
        }
      } else {
        this.showAlert = true;
        this.onOpen();
      }
    });
  }
  isOnList;
  reading() {
    this.isOnList = !this.isOnList;
  }
  voted(id) {
    let curBook;

    this.books.map(book => {
      if (book.id === id) {
        curBook = book;
      }
    });

    this.auth.User.subscribe(data => {
      this.user = data;
      if (this.user) {
        curBook.isVoted = !curBook.isVoted;
        if (curBook.isVoted) {
          curBook.rate = curBook.rate + 1;
          this.bookSer.ediBook(this.id).update({
            rate: curBook.rate,
            isVoted: true
          });
          this.isVoted = true;
        } else {
          curBook.rate = curBook.rate - 1;
          this.bookSer.ediBook(this.id).update({
            rate: curBook.rate,
            isVoted: false
          });
          this.isVoted = false;
        }
      } else {
        console.log("not sure ");
        this.showAlert = true;
        this.onOpen();
      }
    });

    // this.bookSer.getBook(i).then(data => {
    //   curBook = data;
    //   curBook.isVoted = !curBook.isVoted;
    //   console.log(curBook);
    //   if (curBook.isVoted) {
    //     curBook.rate = curBook.rate + 1;
    //     this.Book.ediBook(i).update({
    //       rate: curBook.rate
    //     });
    //   } else {
    //     curBook.rate = curBook.rate - 1;
    //     this.Book.ediBook(i).update({
    //       rate: curBook.rate
    //     });
    //   }
    // });

    // curBook.isVoted = !curBook.isVoted;
    // console.log(this.books[i]);
    // if (curBook.isVoted) {
    //   curBook.rate = curBook.rate + 1;
    // } else {
    //   curBook.rate = curBook.rate - 1;
    // }

    // let book: any;
    // let rate;
    // console.log(this.like);
    // this.Book.getBook(i).then(b => {
    //   book = b;
    //   this.like = book.isVoted;
    //   if (book.isVoted) {
    //     this.Book.ediBook(i).update({
    //       rate: book.rate++
    //     });
    //   } else {
    //     this.Book.ediBook(i).update({
    //       rate: book.rate--
    //     });
    //   }
    // });
    // // console.log(z.fas);
    // if (z.fas) {
    //   book.rate++;
    //   console.log(book.rate);
    // }
    //    else {
    //     book.rate--;
    //     this.Book.ediBook(i).update({
    //       rate: book.rate
    //     });
    //   }
    /*
    if (z.fas) {
      this.Book.getBook(i).then(data => {
        let book = data;
        let rate = book.rate;
        console.log(rate);

        this.Book.ediBook(i).update({
          rate: rate++
        }).then(data=>{
          console.log(data);

        });
      });
      //
    }

*/
  }
  onOpen() {
    console.log(open);
  }
}
